export const MAX_ITEMS = 100;
